<script>

import 'bootstrap-vue/dist/bootstrap-vue.css'
import functions from '../../mixins/import/summary.js';

export default {
	mixins: [functions],
	props: ['id', 'rows', 'mappedColumns'],
	data() {
		return {

			fields: [
				{ key: 'ean', label: 'EAN', sortable: true, sortDirection: 'asc' },
				{ key: 'name', label: 'Name', sortable: true, sortDirection: 'asc' },
				{ key: 'package_size', label: 'Package size', sortable: true, sortDirection: 'asc' },
				{ key: 'selling_price', label: 'Selling price', sortable: true, sortDirection: 'asc' },
				{ key: 'inventory_tracking', label: 'Inventory tracking', sortable: true, sortDirection: 'asc' },
				{ key: 'purchase_price', label: 'Purchase price', sortable: true, sortDirection: 'asc' },
				{ key: 'quantity', label: 'Quantity', sortable: true, sortDirection: 'asc' },
				{ key: 'sku', label: 'SKU', sortable: true, sortDirection: 'asc' }
			],

			copied_fields: [],

			totalRows: 0,
			currentPage: 1,
			search: null,
			sortBy: 'name',
			sortDesc: false,
			perPage: 15,

			sizeIncluded: false,
			nameAndSizeCombined: false,
		}
	},
	mounted() {

		if (this.mappedColumns.includes('quantity') === false) {
			this.fields = this.fields.filter(function(value) {
				return (value.key !== this);
			}, 'quantity');

			this.fields = this.fields.filter(function(value) {
				return (value.key !== this);
			}, 'inventory_tracking');
		}

		if (this.mappedColumns.includes('package_size') === false) {

			this.fields = this.fields.filter(function(value) {
				return (value.key !== this);
			}, 'package_size');

		} else {

			this.copied_fields = this.fields;

		}

		this.totalRows = this.rows.length;
	},
	methods: {
		combine() {

			this.nameAndSizeCombined = true;

			this.fields = this.fields.filter(function(value) {
				return (value.key !== this);
			}, 'package_size');

		},
		cancelCombine() {
			this.nameAndSizeCombined = false;
			this.fields = this.copied_fields;
		},
		downloadFile()
		{
			if (this.nameAndSizeCombined === true) {
				let open = window.open('/import/' + this.id + '/download-file?combine-name-and-size=' + this.nameAndSizeCombined, '_blank');
			} else {
				let open = window.open('/import/' + this.id + '/download-file', '_blank');
			}

			if (open == null || typeof(open) === 'undefined') {
				alert('Turn off your pop-up blocker!');
			}
		}
	}
}
</script>